import '@tamagui/core/reset.css'

import { Button, Form, Input, Checkbox, TamaguiProvider, XStack, YStack, Label, H4, Spinner } from 'tamagui'
import { Check } from '@tamagui/lucide-icons'
import { LinearGradient } from 'tamagui/linear-gradient'
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Header } from '../../components/Header'
import { CheckboxWithLabel } from '../../components/CheckboxWithLabel'
import { registerAccount, RegisterData } from '../../remote/register'

export const Register = () => {
	const navigate = useNavigate()

	const [status, setStatus] = useState<'off' | 'submitting' | 'submitted'>('off')
	useEffect(() => {
		if (status === 'submitting') {
			const timer = setTimeout(() => setStatus('off'), 20000)
			return () => {
				clearTimeout(timer)
			}
		}
	}, [status])

	const [name, setName] = useState('')
	const handleNameInputChange = (event) => {
		setName(event.target.value)
	}

	const [email, setEmail] = useState('')
	const handleEmailInputChange = (event) => {
		setEmail(event.target.value)
	}

	const [phone, setPhone] = useState('')
	const handlePhoneInputChange = (event) => {
		setPhone(event.target.value)
	}

	const [password, setPassword] = useState('')
	const handlePasswordInputChange = (event) => {
		setPassword(event.target.value)
	}

	const submitForm = () => {
		setStatus('submitting')
		registerAccount(new RegisterData(name, email, phone, password), (response) => {
			if (response?.status == 200) {
				setStatus('submitted')
			}
		});
	}

	return (
		<>
			<Header />
			<YStack flex={1} items="center" justify="center">
				<Form
					alignItems="center"
					minWidth={600}
					gap="$2"
					onSubmit={submitForm}
					borderWidth={1}
					borderRadius="$4"
					backgroundColor="$background"
					borderColor="$borderColor"
					padding="$8"
				>
					<H4>Welcome to cytrusted!</H4>
					<XStack alignItems="center" gap="$4">
						<Label htmlFor='name' width={120}>Name</Label>
						<Input id='name' value={name} onChange={handleNameInputChange} size="$4" borderWidth={2} flex={1} />
					</XStack>
					<XStack alignItems="center" gap="$4">
						<Label htmlFor='email' width={120}>Email address</Label>
						<Input id='email' value={email} onChange={handleEmailInputChange} inputMode='email' size="$4" borderWidth={2} flex={1} />
					</XStack>
					<XStack alignItems="center" gap="$4">
						<Label htmlFor='phone' width={120}>Phone number</Label>
						<Input id='phone' value={phone} onChange={handlePhoneInputChange} inputMode='tel' size="$4" borderWidth={2} flex={1} />
					</XStack>
					<XStack alignItems="center" gap="$4">
						<Label htmlFor='password' width={120}>Password</Label>
						<Input id='password' value={password} onChange={handlePasswordInputChange} secureTextEntry={true} size="$4" borderWidth={2} flex={1} />
					</XStack>
					<CheckboxWithLabel size={'$2'} label="I have read and agree to the cytrusted terms of use and privacy policy" />
					<Form.Trigger asChild>
						<Button icon={status === 'submitting' ? () => <Spinner /> : status === 'submitted' ? Check : null}>Register</Button>
					</Form.Trigger>
				</Form>
			</YStack>
		</>
	)
}
